// Tarayıcının yerel yazdırma motoruyla PDF üretimi.
// Site stilleri birebir korunur (vektörel metin, seçilebilir, A4 sayfa bölme @page ile).
// Kullanıcı yazdırma penceresinde hedef olarak "PDF olarak kaydet" seçer.
let activeFinish = null;

export function cancelPrint() {
  activeFinish?.();
}

export async function printDocument(filename) {
  const root = document.documentElement;
  const wasDark = root.classList.contains("dark");
  const oldTitle = document.title;
  // Chrome/Edge varsayılan PDF adını sayfa başlığından alır
  document.title = filename.replace(/\.pdf$/i, "");
  if (wasDark) root.classList.remove("dark");
  root.classList.add("printing");

  try {
    if (document.fonts?.ready) await document.fonts.ready;
    await new Promise((r) => requestAnimationFrame(() => setTimeout(r, 80)));

    await new Promise((resolve) => {
      let done = false;
      let safety = null;
      const finish = () => {
        if (done) return;
        done = true;
        clearTimeout(safety);
        window.removeEventListener("afterprint", finish);
        activeFinish = null;
        resolve();
      };
      activeFinish = finish;
      // Chrome/Firefox: print() diyalog kapanana kadar bloklar ve ardından afterprint gelir.
      // Safari: print() hemen döner, afterprint diyalog kapanınca tetiklenir.
      window.addEventListener("afterprint", finish);
      // afterprint hiç gelmezse (eski tarayıcılar) güvenlik zamanlayıcısı; overlay'deki Kapat da bitirir.
      safety = setTimeout(finish, 90000);
      window.print();
    });
  } finally {
    root.classList.remove("printing");
    if (wasDark) root.classList.add("dark");
    document.title = oldTitle;
  }
}
